import { useState } from 'react';

import { debounce } from '@/components/gnb/utils';

import { DEBOUNCE_TIME } from './constants';

export function useDebouncedDropdownMenuItem(defaultItemName: string) {
  const [currentDropdownMenuItem, setCurrentDropdownMenuItem] =
    useState(defaultItemName);
  const debouncedSetCurrentDropdownMenuItem = debounce(
    setCurrentDropdownMenuItem,
    DEBOUNCE_TIME,
  );

  return [
    currentDropdownMenuItem,
    debouncedSetCurrentDropdownMenuItem,
  ] as const;
}
